<script lang="ts">
  import spinner from "$lib/assets/animated/spinner.svg";

  export let isInitialFetching = false;
  export let hasResult = true;
  export let columns = 3;

</script>
{#if isInitialFetching }
  <div class="full-grid">
    <img src={spinner} width="32" height="32" />
  </div>
{:else if !hasResult}
  <div class="full-grid">
    <div class="text-center mt-4">Non ci sono risultati. Prova a modificare i parametri di ricerca.</div>
  </div>
{:else}
  <section class='simple-cards-grid lg:grid-cols-{columns}'>
      <slot />
  </section>
{/if}

<style type="text/scss" lang="scss" scoped>
  .simple-cards-grid {
    @apply col-span-full;
    @apply grid grid-cols-1 gap-6;
    @apply sm:grid-cols-2;
  }

  .full-grid{
    @apply col-span-full;
    @apply grid grid-cols-1;
    @apply justify-self-center;
  }
</style>
